import React from 'react';
import { Redirect } from 'react-router-dom';
import { useWarehousesScope } from '../../providers/WarehouseScopeProvider';
import WarehouseToolbar from '../WarehouseToolbar/WarehouseToolbar';
import { routePaths } from '../../../../routePaths';
import { InventoryCountsComponent } from '../../../../generated/graphql';
import InventoryCountsTable from './InventoryCountsTable';

const InventoryCounts = () => {
    const { warehouses, currentWarehouseId } = useWarehousesScope();

    return warehouses.length <= 0 ?
        <Redirect to={routePaths.warehouses} />
        : (
            <>
                <WarehouseToolbar />
                <InventoryCountsComponent variables={{ warehouseId: currentWarehouseId as string }}>
                    {({ data: { inventoryCounts } }) => (
                        <InventoryCountsTable inventoryCounts={inventoryCounts} />
                )}
                </InventoryCountsComponent>
            </>
        );
};

export default InventoryCounts;
